import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'next-i18next';

import { PatternDescription, PatternItemContainer, PatternTitle } from './style';

import Image from '@components/atoms/image';
import { getAssetUrl, sanitize } from '@helpers/utils';

interface PatternItemProps {
  index: number;
  title: string;
  description: string;
  imageUrl: string;
}

export const PatternItem = ({ index, title, description, imageUrl }: PatternItemProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <PatternItemContainer>
      <Typography fontSize={18} lineHeight="22px" fontWeight={500} color="#00000099" marginBottom={1} textAlign="left">
        {t('academic_landing_page.lerning_section.pattern', { index: index.toString() })}
      </Typography>
      <Box textAlign="left" flex={1}>
        <PatternTitle>{title}</PatternTitle>
      </Box>
      <Box
        display="flex"
        flexDirection={{
          xs: 'column',
          sm: 'row',
        }}
        justifyContent="space-between"
        alignItems={{
          xs: 'flex-start',
          sm: 'center',
        }}
        gap={3}
      >
        <Box textAlign="left" flex={1}>
          <PatternDescription style={{ fontFamily: theme.typography.h4lanna.fontFamily }}>
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={sanitize(description)}
            />
          </PatternDescription>
        </Box>
        <Box display="flex" height={40} alignSelf={{ xs: 'flex-end', md: 'flex-start' }}>
          {imageUrl && (
            <Image alt={`Pattern ${index}`} src={imageUrl} errorImage={`${getAssetUrl('thumbnail-course-card.jpg')}`} />
          )}
        </Box>
      </Box>
    </PatternItemContainer>
  );
};
